import { BaseApiUrl, IBlockState, BaseApiVersion, ConfigurationInstance } from '@tradingblock/types';
import { getSubdirectory } from '../utils';

export const getAdminPath = path => `${`/admin/${BaseApiVersion}`}${path}`;
export const getPath = path => `${getSubdirectory()}${BaseApiUrl}${path}`;
export const resourceKey = prefix => prefix;
export const objects = {
  favorites: 'favorites',
};
export const database = {
  ...objects,
  dashboard: 'dashboard',
  dashboards: 'dashboards',
  blocks: 'blocks',
  block: 'block',
  configuration: 'configuration',
  settings: 'settings',
};

export const BlockFields: { [F in keyof Pick<IBlockState, 'settings'>]: string } = {
  settings: 'settings',
};

export type ConfigurationFieldNames = 'blockTypeSettings' | 'defaultDashboards';

export const ConfigurationFields: { [T in ConfigurationFieldNames]: string } = {
  blockTypeSettings: `blockTypeSettings`,
  defaultDashboards: 'default-dashboards',
};

export const SettingsFields = {
  blockTypeSettings: `blockTypeSettings`,
};

export const SettingsSubFields = {
  blockTypeSettings: (blockType: string) => `${SettingsFields.blockTypeSettings}.${blockType}`,
};
export const DefaultConfiguration: ConfigurationInstance = {
  blockTypeSettings: {},
  defaultDashboards: [],
};
